import lineChart from './lineChart';

const ivSurfaceChart = {
  options: {
    ...lineChart.options,
    xaxis: {
      type: 'numeric',
      tickAmount: 'dataPoints',
      min: -1,
      max: 1,
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          colors: ['#8c8c8c'],
        },
        formatter: (value) => {
          return `${Math.round(value * 100) / 100}%`;
        },
      },
    },
    tooltip: {
      x: {
        formatter: function (val) {
          return `${val}`;
        },
      },
      y: {
        formatter: function (val) {
          return `${val}%`;
        },
      },
    },
  },
};

export default ivSurfaceChart;
